import * as React from "react";

import {
  Content,
  Item,
  List,
  Root,
  Trigger,
  Viewport,
} from "@radix-ui/react-navigation-menu";
import clsx from "clsx";

import { Box } from "~components/Box";
import { Typography } from "~components/Typography";

import { Callout } from "~sections/Nav/desktop/_Callout";
import { NavLink } from "~sections/Nav/desktop/_NavLink";

import { type Nav as NavProps } from "../Nav.types";
import { ListItem } from "./_ListItem";
import * as styles from "./styles.css";

export function NavDesktop({ navCategories }: NavProps) {
  return (
    <Root className={styles.navigationMenuRoot}>
      <List className={styles.navigationMenuList}>
        {navCategories.map((navCategory) => {
          const {
            title,
            categories,
            extra: extraArray,
            callOut: callOutArray,
            link,
          } = navCategory;

          const extra = extraArray && extraArray[0];
          const callOut = callOutArray && callOutArray[0];

          if (categories && !link?.id) {
            return (
              <Item value={title} key={title}>
                <Trigger className={styles.navigationMenuTrigger}>
                  {title}
                </Trigger>
                <Content className={styles.navigationMenuContentWrapper}>
                  <Box className={styles.navigationMenuContent}>
                    {categories?.map((category) => {
                      return (
                        <Box
                          className={styles.navigationMenuCategoryWrapper}
                          key={category.title}
                        >
                          {category.title && (
                            <Typography
                              textAppearance="body_sm"
                              fontWeight="bold"
                              className={styles.navigationMenuCategoryHeading}
                              aria-hidden
                            >
                              {category.title}
                            </Typography>
                          )}
                          <ul className={styles.navigationMenuCategory}>
                            {category?.listItems?.map((listItem) => {
                              return (
                                <ListItem
                                  title={listItem.title}
                                  link={listItem.link}
                                  icon={listItem.icon}
                                  key={listItem.title}
                                  subListItems={listItem?.subListItems}
                                >
                                  {listItem?.description}
                                </ListItem>
                              );
                            })}
                          </ul>
                        </Box>
                      );
                    })}
                    {extra && (
                      <Box
                        className={clsx(
                          styles.navigationMenuCategoryWrapper,
                          styles.navigationMenuExtraWrapper
                        )}
                        key={extra.title}
                      >
                        {extra.title && (
                          <Typography
                            textAppearance="body_sm"
                            fontWeight="bold"
                            className={styles.navigationMenuCategoryHeading}
                            aria-hidden
                          >
                            {extra.title}
                          </Typography>
                        )}
                        <ul
                          className={clsx(
                            styles.navigationMenuExtra,
                            styles.navigationMenuCategory
                          )}
                        >
                          {extra.subListItems.map((subListItem) => {
                            return (
                              <ListItem
                                title={subListItem.title}
                                link={subListItem.link}
                                key={subListItem.title}
                              />
                            );
                          })}
                        </ul>
                      </Box>
                    )}
                  </Box>
                  {callOut && <Callout {...callOut} />}
                </Content>
              </Item>
            );
          }

          if (link?.id && !categories?.length) {
            return (
              <Item value={title} key={title}>
                <NavLink title={title} link={link} />
              </Item>
            );
          }

          return null;
        })}
      </List>

      <div className={styles.viewportPosition}>
        <Viewport className={styles.navigationMenuViewport} />
      </div>
    </Root>
  );
}
